import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

/*
 * The page body comes from the shared UseCases section, so the only string this page
 * owns is its breadcrumb crumb.
 */
const USE_CASES_PAGE_DEFINITIONS = {
  BREADCRUMB: {
    id: 'use_cases.breadcrumb',
    text: 'Use cases',
    description:
      'Name of this page in the schema.org BreadcrumbList structured data, following the "Home" crumb. A navigation trail label, so keep it short.',
  },
};

export const UseCasesPageMessages = defineMessages(USE_CASES_PAGE_DEFINITIONS);

/** English fallbacks, used until `npm run lx:extract` adds these ids to en-US.json. */
export const UseCasesPageText = englishText(USE_CASES_PAGE_DEFINITIONS);
